module.exports = __webpack_public_path__ + "img/Tour Elite.137128c1.jpg";